import {Dispatch, SetStateAction, useEffect, useState} from 'react';

export const useInitialState = <T>(initialState: T): [T, Dispatch<SetStateAction<T>>] => {
  const [init, setInit] = useState<T>(initialState);
  useEffect(() => {
    setInit(initialState);
  }, [initialState]);
  return [init, setInit];
};
